'use strict';

var veroEvents = require('./veroEvents');

var OperationType = Object.freeze({
  LOGIN: 'login',
  REGISTER: 'register',
  VERIFY_ACCOUNT: 'verify_account'
});

var operationVeroEvents = Object.freeze({
  login: veroEvents.magicLinkLogin,
  register: veroEvents.magicLinkRegister,
  verify_account: veroEvents.magicLinkBaseUserRegistration
});

module.exports = {
  OperationType: OperationType,
  operationVeroEvents: operationVeroEvents
};